/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {markWidgetUsed} from '../api'

export const useMutationMarkWidgetUsed = createReactQueryMutationHook('markWidgetUsed', markWidgetUsed)
